// Ventanas de tiempo del apartado de Bókun y del pago (sin dependencias de servidor).

/** Bókun libera un apartado RESERVED a los 30 minutos de crearlo. */
export const BOKUN_HOLD_MINUTES = 30;
/** El cliente tiene 25 minutos para pagar: 5 de margen antes de que Bókun libere. */
export const PAY_WINDOW_MINUTES = 25;
/** Por encima de esta edad no se confía en el apartado: se vuelve a apartar antes de cobrar. */
export const SAFE_CONFIRM_MINUTES = 27;
/** Stripe exige que una sesión de pago viva al menos 30 minutos. */
export const STRIPE_MIN_SESSION_SECONDS = 30 * 60 + 30;

export function payDeadline(reservedAtMs: number): number {
  return reservedAtMs + PAY_WINDOW_MINUTES * 60_000;
}

/** ¿El apartado sigue siendo confiable para confirmar sin volver a apartar? */
export function holdStillValid(reservedAtMs: number, nowMs: number = Date.now()): boolean {
  return nowMs - reservedAtMs < SAFE_CONFIRM_MINUTES * 60_000;
}

/** Segundos restantes del plazo de pago (nunca negativo). */
export function secondsLeft(deadlineMs: number, nowMs: number = Date.now()): number {
  return Math.max(0, Math.floor((deadlineMs - nowMs) / 1000));
}
